import * as amplitude from "@amplitude/analytics-react-native"
import FilledButtonM from "@common/components/button/FilledButtonM"
import TextM from "@common/components/text/TextM"
import { useCamera } from "@common/hooks/useCamera"
import { theme } from "@common/theme/theme"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { clearLastPhoto } from "@data/redux/actions/camera"
import { useNavigation, useRoute } from "@react-navigation/native"
import * as DocumentPicker from "expo-document-picker"
import moment from "moment"
import React, { useContext, useEffect, useState } from "react"
import { Image, ScrollView, View } from "react-native"
import { connect, useDispatch } from "react-redux"
import logo from "../../../assets/logo-blue.png"
import { DimensionsContext, isWebMobile } from "../../common/utils/mobileUtils"
import { extendedStudentClasses } from "../../data/constants/formConstants"
import { setCameraStatus } from "../../data/redux/actions/activity"
import { saveReportFile } from "../../data/redux/actions/formData"
import { CGUText } from "../../student/account/onboarding/CGUText"
import { SelectInputM } from "../../student/account/onboarding/SelectInputM"
import { ChampionImageM } from "../../student/champions/ChampionImageM"

function ScanScreen(props) {
    const navigation = useNavigation()
    const route = useRoute()
    const dispatch = useDispatch()
    const dimensions = useContext(DimensionsContext)
    const error = route?.params?.error || false

    const width =
        dimensions.width > 800 ? dimensions.width / 2.2 : dimensions.width - 60

    const [launchCamera] = useCamera("school-card-report")

    const [file, setFile] = useState(null)
    const [selectedClass, setSelectedClass] = useState(null)

    useEffect(() => {
        if (props.lastPhotoFormId === "school-card-report") {
            setFile(props.lastPhoto)
            setCameraStatus(false)
        }

        return () => {
            setCameraStatus(false)
            props.clearLastPhoto()
        }
    }, [props, navigation])

    const pickFile = async () => {
        const result = await DocumentPicker.getDocumentAsync({
            type: ["application/pdf", "image/*"],
        })

        if (!result.canceled) {
            setFile(result.assets[0])
        }
    }

    useEffect(() => {
        if (file) {
            const cleanFormData = new FormData()
            cleanFormData.append("temporary_id", "test")

            let mimeType = "application/pdf"
            let extension = "pdf"

            if (file.mimeType) {
                mimeType = file.mimeType
                extension = mimeType.split("/")[1]
            } else if (file.type) {
                mimeType = file.type
                extension = mimeType.split("/")[1]
            } else if (file.uri) {
                if (file.uri.startsWith("data:")) {
                    const dataUrlParts = file.uri
                        .split(",")[0]
                        .split(":")[1]
                        .split(";")[0]
                    if (dataUrlParts) {
                        mimeType = dataUrlParts
                        extension = mimeType.split("/")[1]
                    }
                } else {
                    const uriParts = file.uri.split(".")
                    if (uriParts.length > 1) {
                        extension = uriParts[uriParts.length - 1].toLowerCase()

                        const mimeMap = {
                            jpg: "image/jpeg",
                            jpeg: "image/jpeg",
                            png: "image/png",
                            pdf: "application/pdf",
                        }

                        mimeType = mimeMap[extension] || `image/${extension}`
                    }
                }
            }

            const fileToUpload = {
                uri: file.uri,
                name: `Masteur_File_${moment().format(
                    "YYYY-MM-DD"
                )}.${extension}`,
                type: mimeType,
            }

            dispatch(saveReportFile(fileToUpload)).then(() => {
                navigation.navigate("school-card-report/loading", {
                    student_class: selectedClass,
                })
            })
        }
    }, [file])

    useEffect(() => {
        amplitude.track("school_card_report.scan_screen")
    }, [])

    return (
        <View style={{ flex: 1, width: "100%" }}>
            <ScrollView
                showsVerticalScrollIndicator={false}
                showsHorizontalScrollIndicator={false}
                horizontal={false}
                style={{ flex: 1, width: "100%" }}
                contentContainerStyle={{
                    flexGrow: 1,
                    alignItems: "center",
                    ...(isWebMobile() && { minHeight: "100dvh" }),
                }}
            >
                <View
                    style={{
                        width: "100%",
                        paddingTop: 20,
                        marginBottom: 20,
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Image
                        source={logo}
                        style={{
                            width,
                            height: 120,
                            resizeMode: "contain",
                            borderRadius: 8,
                        }}
                    />

                    <TextM
                        fontSize={32}
                        fontWeight="ExtraBold"
                        color={theme.colors.primary}
                        style={{
                            textAlign: "center",
                            marginHorizontal: 16,
                            marginTop: 20,
                        }}
                        wrap
                    >
                        Scannez un bulletin scolaire !
                    </TextM>
                    <TextM
                        fontSize={14}
                        fontWeight="Medium"
                        color={theme.colors.grey}
                        style={{
                            textAlign: "center",
                            marginHorizontal: 16,
                        }}
                        wrap
                    >
                        Recevez votre bilan personnalisé en quelques instants
                    </TextM>

                    <View
                        style={{
                            width: width * 0.8,
                        }}
                    ></View>

                    <View
                        style={{
                            width: "100%",
                            marginBottom: 24,
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <ChampionImageM
                            name="zoe"
                            variant={error ? "unhappy" : "main"}
                            width={(width * 1) / 3}
                        />

                        {error && (
                            <TextM
                                fontSize={16}
                                fontWeight="regular"
                                color={theme.colors.error}
                                style={{
                                    marginTop: 20,
                                    textAlign: "center",
                                }}
                                wrap
                            >
                                {
                                    "L'analyse de ton bulletin a échoué. Merci de réessayer."
                                }{" "}
                            </TextM>
                        )}
                    </View>
                </View>

                <View style={{ flex: 1 }} />

                <View
                    style={{
                        width: "100%",
                        paddingHorizontal: 20,
                        marginBottom: 20,
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <CGUText
                        fontSize={10}
                        style={{
                            marginBottom: 20,
                            marginHorizontal: 20,
                            maxWidth:
                                dimensions?.width < 800
                                    ? dimensions?.width - 40
                                    : dimensions?.width / 2,
                        }}
                    />
                    <SelectInputM
                        label="Sélectionnez la classe"
                        sliderLabel="Choisissez votre niveau"
                        options={extendedStudentClasses}
                        value={selectedClass}
                        onSelect={(value) => {
                            setSelectedClass(value)
                            amplitude.track("school_card_report.select_class", {
                                class: value,
                            })
                        }}
                        style={{
                            marginVertical: 4,
                            marginBottom: 10,
                            width:
                                dimensions?.width < 800
                                    ? dimensions?.width - 40
                                    : dimensions?.width / 2,
                        }}
                        optionHeight={45}
                    />

                    <FilledButtonM
                        mode={"contained"}
                        icon={"images"}
                        color={theme.colors.success}
                        style={{
                            width,
                        }}
                        onPress={pickFile}
                        trackingId={"school_card_report.pick_file"}
                        label={"Insérer un fichier"}
                        disabled={!selectedClass}
                    />
                    <FilledButtonM
                        mode={"contained"}
                        icon={"camera"}
                        color={theme.colors.accent}
                        style={{
                            width,
                        }}
                        trackingId={"school_card_report.launch_camera"}
                        onPress={launchCamera}
                        label={"Prendre une photo"}
                        disabled={!selectedClass}
                    />
                </View>
            </ScrollView>
        </View>
    )
}

const mapStateToProps = (state) => ({
    lastPhoto: state.camera?.lastPhoto,
    lastPhotoFormId: state.camera?.formId,
})

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    clearLastPhoto,
}

export default connect(mapStateToProps, mapDispatchToProps)(ScanScreen)
